import * as Ably from 'ably'
import { createContext, useContext } from 'react'
import { AblyProvider, ChannelProvider } from 'ably/react'

interface AblyContextProps {
  client: Ably.Realtime | null
  meetingId: string
}

const AblyContext = createContext<AblyContextProps | undefined>(undefined)

const AblyGlobalProvider = ({
  children,
  meetingId,
}: {
  children: React.ReactNode
  meetingId: string
}) => {
  const client = new Ably.Realtime(process.env.REACT_APP_ABLY_API_KEY!)

  return (
    <AblyProvider client={client}>
      <ChannelProvider channelName={meetingId}>
        <AblyContext.Provider value={{ client, meetingId }}>
          {meetingId && children}
        </AblyContext.Provider>
      </ChannelProvider>
    </AblyProvider>
  )
}

export const useAbly = () => useContext(AblyContext)
export default AblyGlobalProvider
